module.exports = __webpack_public_path__ + "static/ki_rin-a9dbd1c4be268af64018a10f2e3d8e97.jpeg";